import { Injectable } from '@angular/core';
import { FC_CoolerCpuMother } from '../funcionesCompatibilidad/FC_CoolerCpuMother';
import { FC_CpuMother } from '../funcionesCompatibilidad/FC_CpuMother';
import { FC_MotherDisco } from '../funcionesCompatibilidad/FC_MotherDisco';
import { FC_MotherFuente } from '../funcionesCompatibilidad/FC_MotherFuente';
import { FC_MotherGabinete } from '../funcionesCompatibilidad/FC_MotherGabinete';
import { FC_MotherMemoria } from '../funcionesCompatibilidad/FC_MotherMemoria';
import { FC_MotherVideo } from '../funcionesCompatibilidad/FC_MotherVideo';
import { Incompatibilities } from '../Incompatibilities';
import { Mother } from '../model';
import { DataArmado } from './DataArmado';
import { FuncionesArmadoBase } from './FuncionesArmadoBase';
import { IncompatibilitiesType } from '@core/enums/incompatibilities-types.enum';

@Injectable({
  providedIn: 'root',
})
export class FA_Mother extends FuncionesArmadoBase<Mother> {
  constructor(
    private fc_CpuMother: FC_CpuMother,
    private fc_motherVideo: FC_MotherVideo,
    private fc_motherMemoria: FC_MotherMemoria,
    private fc_motherGabinete: FC_MotherGabinete,
    private fc_motherFuente: FC_MotherFuente,
    private fc_motherDisco: FC_MotherDisco,
    private fc_coolerCpuMother: FC_CoolerCpuMother,
  ) {
    super();
  }
  funciones = {
    cpu: (dataArmado: DataArmado, mother: Mother) => {
      let cpu = dataArmado.cpus[0];
      if (!cpu) return [];
      return this.fc_CpuMother.ejecutar(cpu, mother);
    },
    video: (dataArmado: DataArmado, mother: Mother) => {
      let videos = dataArmado.placasVideos;
      if (!videos.length) return [];
      return videos.reduce((array, video) => {
        array.push(...this.fc_motherVideo.ejecutar(mother, video));
        return array;
      }, []);
    },
    memoria: (dataArmado: DataArmado, mother: Mother) => {
      let memorias = dataArmado.memorias;
      if (!memorias.length) return [];
      return memorias.reduce((array, memoria) => {
        array.push(...this.fc_motherMemoria.ejecutar(mother, memoria));
        return array;
      }, []);
    },
    gabinete: (dataArmado: DataArmado, mother: Mother) => {
      let gabinete = dataArmado.gabinetes[0];
      if (!gabinete) return [];
      return this.fc_motherGabinete.ejecutar(mother, gabinete);
    },
    fuente: (dataArmado: DataArmado, mother: Mother) => {
      let fuente = dataArmado.fuentes[0];
      if (!fuente) return [];
      return this.fc_motherFuente.ejecutar(mother, fuente);
    },
    disco: (dataArmado: DataArmado, mother: Mother) => {
      let discos = dataArmado.discos;
      if (!discos) return [];
      return discos.reduce((array, disco) => {
        array.push(...this.fc_motherDisco.ejecutar(mother, disco));
        return array;
      }, []);
    },
    coolercpu: (dataArmado: DataArmado, mother: Mother) => {
      let coolercpus = dataArmado.ccpu;
      if (!coolercpus.length) return [];
      return coolercpus.reduce((array, coolercpu) => {
        array.push(...this.fc_coolerCpuMother.ejecutar(coolercpu, mother));
        return array;
      }, []);
    },
    cantidadMemorias: (dataArmado: DataArmado, mother: Mother) => {
      let memorias = dataArmado.memorias;
      if (!memorias.length) return [];
      let tipoMem = memorias[0].$caracteristicas.tipo;
      let cantidadMemoriasSeleccionadas = memorias.reduce(
        (cantidad, mem) => cantidad + mem.$caracteristicas.slot,
        0,
      );
      return mother.$caracteristicas[tipoMem] < cantidadMemoriasSeleccionadas ?
          [{ tipo: IncompatibilitiesType.ARMADO, incompatibility: 'Slot de memorias insuficiente' }]
        : null;
    },
    cantidadDiscos: (dataArmado: DataArmado, mother: Mother) => {
      let discos = dataArmado.discos;
      if (!discos.length) return [];
      let cantidadDiscosSeleccionados = discos.reduce(
        (result, discoActual) => {
          let tipoDisco = discoActual.$caracteristicas.tipo;
          let cantidad: number = result[tipoDisco == 'M2' ? 'm2' : tipoDisco] + 1 || 1;
          result[tipoDisco == 'M2' ? 'm2' : tipoDisco] = cantidad;
          return result;
        },
        {} as { [x: string]: number },
      );
      const incompatibilidades: Array<Incompatibilities> = [];
      for (const tipo in cantidadDiscosSeleccionados) {
        if (mother.$caracteristicas[tipo] < cantidadDiscosSeleccionados[tipo]) {
          incompatibilidades.push({
            tipo: IncompatibilitiesType.ARMADO,
            incompatibility: `Slot de discos ${tipo} insuficiente`,
          });
        }
      }

      return incompatibilidades?.length ? incompatibilidades : null;
    },
    cantidadPlacasVideo: (dataArmado: DataArmado, mother: Mother) => {
      let placasVideos = dataArmado.placasVideos;
      if (!placasVideos.length) return [];
      let cantidadPlacasSeleccionadas = placasVideos.reduce(
        (result, placaActual) => {
          let tipoPlaca =
            placaActual.$caracteristicas.tipo == 'pcie' ?
              'nro_pcie'
            : placaActual.$caracteristicas.tipo;
          let cantidad: number = result[tipoPlaca] + 1 || 1;
          result[tipoPlaca] = cantidad;
          return result;
        },
        {} as { [x: string]: number },
      );
      const incompatibilidades: Array<Incompatibilities> = [];
      for (const tipo in cantidadPlacasSeleccionadas) {
        if (mother.$caracteristicas[tipo] < cantidadPlacasSeleccionadas[tipo]) {
          incompatibilidades.push({
            tipo: IncompatibilitiesType.ARMADO,
            incompatibility: `Slot de placas ${tipo} insuficiente`,
          });
        }
      }

      return incompatibilidades?.length ? incompatibilidades : null;
    },
  };
}
